import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "../../../components/ui/form";
import { Input } from "../../../components/ui/input";
import { z } from "zod";
import Ic_logo_white from "../../../assets/images/Ic_logo_white.svg";
import Ic_logo from "../../../assets/images/Ic_logo.svg";
import Img_login from "../../../assets/images/Img_login.png";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/common/button";
import axios from "axios";
import { useState } from "react";
import { Spinner } from "../../../components/Spinner";

export const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const formSchema = z.object({
    email: z
      .string()
      .email({ message: "Vennligst skriv inn en gyldig e-postadresse." })
      .min(1, { message: "E-postadresse er påkrevd." }),

    password: z
      .string()
      .min(8, { message: "Passordet må være minst 8 tegn langt." })
      .regex(/[A-Z]/, {
        message: "Passordet må inneholde minst én stor bokstav.",
      })
      .regex(/[a-z]/, {
        message: "Passordet må inneholde minst én liten bokstav.",
      })
      .regex(/[0-9]/, { message: "Passordet må inneholde minst ett tall." })
      .regex(/[@$!%*?&]/, {
        message: "Passordet må inneholde minst ett spesialtegn.",
      }),
  });

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
  });

  const onSubmit = async (data: z.infer<typeof formSchema>) => {
    setLoading(true);

    // try {
    //   const adminDocRef = doc(db, "admin", data.email);
    //   const adminSnap = await getDoc(adminDocRef);

    //   if (!adminSnap.exists()) {
    //     toast.error("Admin finnes ikke", { position: "top-right" });
    //   } else {
    //     const adminData = adminSnap.data();
    //     const storedPassword = adminData?.password;

    //     if (adminData?.supplier !== "9f523136-72ca-4bde-88e5-de175bc2fc71") {
    //       if (!storedPassword) {
    //         if (data.password) {
    //           const hashedPassword = bcrypt.hashSync(data.password, 10);
    //           await updateDoc(adminDocRef, { password: hashedPassword });

    //           localStorage.setItem("Iplot_admin", data.email);
    //           const loginUserData = await fetchAdminDataByEmail();
    //           if (loginUserData) {
    //             if (
    //               loginUserData?.role &&
    //               loginUserData?.role === "Bankansvarlig"
    //             ) {
    //               navigate("/bank-leads");
    //             } else if (
    //               loginUserData?.role &&
    //               loginUserData?.role === "Agent"
    //             ) {
    //               navigate("/agent-leads");
    //             } else {
    //               navigate("/dashboard");
    //             }
    //           }
    //           toast.success("Logg inn", {
    //             position: "top-right",
    //           });
    //         }
    //       } else {
    //         const isPasswordCorrect = bcrypt.compareSync(
    //           data.password,
    //           storedPassword
    //         );
    //         if (isPasswordCorrect) {
    //           localStorage.setItem("Iplot_admin", data.email);
    //           const loginUserData = await fetchAdminDataByEmail();
    //           if (loginUserData) {
    //             if (
    //               loginUserData?.role &&
    //               loginUserData?.role === "Bankansvarlig"
    //             ) {
    //               navigate("/bank-leads");
    //             } else if (
    //               loginUserData?.role &&
    //               loginUserData?.role === "Agent"
    //             ) {
    //               navigate("/agent-leads");
    //             } else {
    //               navigate("/dashboard");
    //             }
    //             toast.success("Logg inn", { position: "top-right" });
    //           }
    //         } else {
    //           toast.error("Incorrect password", { position: "top-right" });
    //         }
    //       }
    //     } else {
    //       toast.error("Vennligst logg inn som Bolig Partner-bruker.", {
    //         position: "top-right",
    //       });
    //     }
    //   }
    // } catch (error) {
    //   console.error("Error during sign-in", error);
    // }

    try {
      const res = await axios.post(
        "https://us-central1-l-plot.cloudfunctions.net/loginAdminHttp",
        {
          email: data?.email,
          password: data?.password,
        }
      );

      if (res.data?.success === true) {
        localStorage.setItem("__Iplot_admin_access_", res?.data?.userData?.id);
        navigate(res?.data?.redirectPath);
        toast.success(res?.data?.message, {
          position: "top-right",
        });
      }
    } catch (err: any) {
      toast.error(err?.response?.data?.message, {
        position: "top-right",
      });
      console.error(err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Spinner />}

      <div className="flex items-center gap-4 p-3 h-screen">
        <div className="relative h-full hidden lg:block">
          <img src={Img_login} alt="login_image" className="h-full w-auto" />
          <img
            src={Ic_logo_white}
            alt="logo"
            className="absolute top-6 left-6"
          />
        </div>
        <div className="flex-1">
          <div className="flex items-center justify-center">
            <div className="relative w-full max-w-[490px]">
              <div
                className="bg-white p-6 md:p-8 w-full rounded-lg"
                style={{
                  boxShadow: "0px 4px 10px 0px #0000001A",
                }}
              >
                <div className="flex lg:hidden items-center justify-center mb-6 md:mb-8">
                  <img src={Ic_logo} alt="logo" />
                </div>
                <div className="flex flex-col gap-1.5 mb-6 md:mb-8">
                  <h3 className="text-darkBlack font-semibold text-lg md:text-xl desktop:text-2xl text-center">
                    Velkommen tilbake!
                  </h3>
                  <p className="text-gray4 text-xs md:text-sm text-center">
                    Skriv inn e-post og passord for å logge inn på kontoen din.
                  </p>
                </div>
                <Form {...form}>
                  <form
                    onSubmit={form.handleSubmit(onSubmit)}
                    className="relative"
                  >
                    <div className="grid grid-cols-1 gap-6">
                      <div>
                        <FormField
                          control={form.control}
                          name="email"
                          render={({ field, fieldState }) => (
                            <FormItem>
                              <p
                                className={`${
                                  fieldState.error ? "text-red" : "text-black"
                                } mb-[6px] text-sm font-medium`}
                              >
                                E-post
                              </p>
                              <FormControl>
                                <div className="relative">
                                  <Input
                                    placeholder="Skriv inn E-post"
                                    {...field}
                                    className={`bg-white rounded-[8px] border text-black
                                          ${
                                            fieldState?.error
                                              ? "border-red"
                                              : "border-gray1"
                                          } `}
                                    type="text"
                                  />
                                </div>
                              </FormControl>
                              <FormMessage />
                            </FormItem>
                          )}
                        />
                      </div>
                      <div>
                        <FormField
                          control={form.control}
                          name="password"
                          render={({ field, fieldState }) => (
                            <FormItem>
                              <p
                                className={`${
                                  fieldState.error ? "text-red" : "text-black"
                                } mb-[6px] text-sm font-medium`}
                              >
                                Passord
                              </p>
                              <FormControl>
                                <div className="relative">
                                  <Input
                                    placeholder="Skriv inn Passord"
                                    {...field}
                                    className={`bg-white rounded-[8px] border text-black
                                          ${
                                            fieldState?.error
                                              ? "border-red"
                                              : "border-gray1"
                                          } `}
                                    type="password"
                                  />
                                </div>
                              </FormControl>
                              <FormMessage />
                            </FormItem>
                          )}
                        />
                      </div>
                    </div>
                    <div className="flex justify-end w-full gap-5 items-center mt-6 md:mt-8">
                      <div onClick={() => form.reset()}>
                        <Button
                          text="Avbryt"
                          className="border border-gray2 text-black text-sm rounded-[8px] h-[40px] font-medium relative px-4 py-[10px] flex items-center gap-2"
                        />
                      </div>
                      <Button
                        text="Lagre"
                        className="border border-primary bg-primary text-white text-sm rounded-[8px] h-[40px] font-medium relative px-4 py-[10px] flex items-center gap-2"
                        type="submit"
                      />
                    </div>
                  </form>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
